export default {
	orgAll(state){ return state.orgAll; },
	orginf(state){ return state.infoorg; },
	getFormInfo(state){ return state.formInfo; },
	getVarChangeOrg(state){ return state.varChangeOrg; },
	getPlanId(state){ return state.plan_id; },
	getStatusBilling(state){ return state.statusBilling; },
}
